import type { BulkEditSelectFieldSpec } from 'elements/listBulkEdit/BulkEditSelectFormFields'
import { BulkEditSelectFormFields } from 'elements/listBulkEdit/BulkEditSelectFormFields'
import React, { useCallback } from 'react'
import { PerformanceCalculatorFormRow, WeatherDatasetFormRow } from '../ProjectConfigurationEnergyFields'

// Django: BulkUpdateViewSet.RESOURCE_BULK_SPECS['project_configurations'].bulk_update_fields (project/views.py)
export const PROJECT_CONFIGURATION_BULK_SELECT_FIELD_SPECS: readonly BulkEditSelectFieldSpec[] = [
  { source: 'performance_calculator', renderField: PerformanceCalculatorFormRow, allowEmpty: true },
  { source: 'weather_dataset', renderField: WeatherDatasetFormRow, allowEmpty: true },
]

export const PROJECT_CONFIGURATION_BULK_FORM_FIELD_KEYS = PROJECT_CONFIGURATION_BULK_SELECT_FIELD_SPECS.map(
  (fieldSpec) => fieldSpec.source
)

export const ProjectConfigurationBulkEditFormFields: React.FC<{
  fieldSpecs: readonly BulkEditSelectFieldSpec[]
  disabled?: boolean
  visibleFieldKeys?: string[] | null
}> = ({ fieldSpecs, ...props }) => {
  const getChoicesForValues = useCallback(() => ({}), [])
  return (
    <BulkEditSelectFormFields
      resource="project_configurations"
      fieldSpecs={fieldSpecs}
      getChoicesForValues={getChoicesForValues}
      {...props}
    />
  )
}

export function buildProjectConfigurationBulkPatch(formValues: Record<string, unknown>): Record<string, unknown> {
  const patch: Record<string, unknown> = {}
  const performanceCalculatorRaw = formValues.performance_calculator
  if (performanceCalculatorRaw != null && performanceCalculatorRaw !== '') {
    patch.performance_calculator = Number(performanceCalculatorRaw)
  }
  const weatherDatasetRaw = formValues.weather_dataset
  if (weatherDatasetRaw != null && weatherDatasetRaw !== '') {
    patch.weather_dataset = Number(weatherDatasetRaw)
  }
  return patch
}
